import { put, takeEvery } from 'redux-saga/effects';
import {
  deleteTemplateSuccess,
  deleteTemplateFailure,
} from 'redux/template/actions';
import { Notify } from '@flexisaf/flexibull2';
import request from 'utils/request';
import urls from 'utils/config';
import TemplatesActionTypes from '../types';
import { TOP_RIGHT, SUCCESS } from 'utils/constants';
import { networkErrorHandler } from 'utils/errrorHandlers';

const { TEMPLATE_BASE_URL } = urls || {};

export function* deleteTemplate({ payload }) {
  const { id, type } = payload;
  const url = `${TEMPLATE_BASE_URL}/templates/${id}`;

  const response = yield request({
    method: 'delete',
    url,
  });

  if (response.success) {
    yield put(deleteTemplateSuccess(id, type));
    Notify('Template Deleted Successfully!', {
      position: TOP_RIGHT,
      status: SUCCESS,
    });
  } else {
    networkErrorHandler(response?.statusCode, `Failed to Delete Template: ${response.message}`);
    yield put(deleteTemplateFailure(response.message));
  }
}

export function* onTemplateDelete() {
  yield takeEvery(TemplatesActionTypes.START_DELETE_TEMPLATES, deleteTemplate);
}
